import { useState, ReactNode, Dispatch } from 'react';
import clsx from 'clsx';
import { getAccountsResponse } from '@shared/api/rest/accounts';
import { useNavigate } from 'react-router';
import { RoutePaths } from '@shared/utils';
import { useParams } from 'react-router';
import { GetCardsResponse } from '@shared/api/rest/misc';

interface SlideItemType {
  className?: string;
  children: ReactNode;
  style?: { width: string | number; height: string | number };
  account?: getAccountsResponse;
  card?: GetCardsResponse;
  accountsPage?: boolean;
  setSelectedCard?: Dispatch<React.SetStateAction<GetCardsResponse | undefined>>;
}

export const SlideItem = (props: SlideItemType) => {
  const params = useParams();
  const navigate = useNavigate();
  const [active, setActive] = useState(false);

  const isActive = params.id === props.account?.Id;

  const flipItem = () => {
    if (props.accountsPage) {
      !isActive && navigate(RoutePaths.accounts.onNavigate(props.account?.Id as string));
    }
    if (props.setSelectedCard) {
      props.setSelectedCard(props.card);
    }
    setActive((prevActive) => !prevActive);
  };

  return (
    <div style={props.style} className={props.className} onClick={flipItem}>
      <div className='h-full w-full perspective-[1000px]'>
        <div
          className={clsx(
            'relative h-full transition-all duration-600',
            props.accountsPage ? (isActive ? 'rotate-y-180' : '') : active ? 'rotate-y-180' : '',
          )}
          style={{ transformStyle: 'preserve-3d' }}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};
